module.exports = __webpack_public_path__ + "static/ik-3-1ff6e16d6583b27c2b9821ef932e9c7a.png";